import React, { useRef, useEffect } from "react"
import mapboxgl from "mapbox-gl"
import { NationalParkCoordinates } from '../../models/NationalPark';

interface Props {    
    map: any;
    coordinates: NationalParkCoordinates;
}

export default function CustomMarker({ map, coordinates }: Props) {
    const markerRef: any = useRef();

    useEffect((): any => {
      const marker = new mapboxgl.Marker(markerRef)
        .setLngLat([coordinates.longitude, coordinates.latitude])
        .addTo(map)
  
      return () => marker.remove()
    })

  return (
    <div ref={markerRef} />
  );
}